import React, { useEffect, useState } from 'react'
import {Form, Button} from 'react-bootstrap'
import './App.css'
import enviarContato from './libs/contato'
import write from './libs/pedidos'
import image from './img/WhatsAppButtonWhiteMedium.png'
import ClickVendas from './components/ClickVendas'
import axios from "axios";
// import tabelaPreco from './libs/precos'
function FormPedidos() {
  const [qtde, setQtde ] = useState(0)
  const [id, setId ] = useState('')
  const [tabelaPreco , setTabelaPreco] = useState([])
  const baseURL = "https://standalone-express.vercel.app/api/handler"
  const upPedido = (e)=>{
    e.preventDefault()

  }
  const change = (e)=>{
    const value = e.target.value
    setQtde(value)
  }
  const downPedido = (index)=>{
    alert(index)
  }
  useEffect(()=>{
    axios.get(baseURL).then((response) => {
      setTabelaPreco(response.data);

    })
  },[])
  const lancheItems = tabelaPreco.map((lanche, index) => {
    
    return (
      <li key={index} className="preco" id={lanche.name}>
        Descrição: { lanche.descricao }<br />
        Preço: {new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(lanche.preco)}<br />
        <ClickVendas change={change} qtde={qtde} index={index} name={lanche.name} updateQtde={write.update} />
      </li>
    );
  });
  return (
    <>
    <section className="page-main">
    <h2>Adicionar itens ao pedido</h2>
    <ul className="pedidos-form">
      { lancheItems }
    </ul>

    </section>
    </>
  );
}

export default FormPedidos;
